import setupAxios from './Base'

const axios = setupAxios()

export default class Logon {
  constructor() {
    axios.defaults.withCredentials = true
  }

  getToken(params) {
    return axios.get('/logon/getToken' + params)
  }

  getExternalToken(data) {
    return axios.post('/logon/loginExternalIntegration', data)
  }
}
